const IMPORT = {
  OPEN_MODAL: 'Import > Open modal',
}
const IMPORT_DOCUMENT = 'Import document'

export {
  IMPORT,
  IMPORT_DOCUMENT,
}
